module.exports = __webpack_public_path__ + "static/media/less-than-equal.4d55e586.svg";